import React, { useState } from 'react';
import {
	Container,
	Row,
	Col,
	Accordion,
	AccordionBody,
	AccordionHeader,
	AccordionItem,
	Badge,
	Card,
	CardBody,
	Spinner
} from 'reactstrap';
import Breadcrumbs from '../../components/Common/Breadcrumb';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
const ContractRates = props => {
	let [isLoading, setIsLoading] = useState(false);
	const [open, setOpen] = useState('68be6abbbc64c23b42025ad8');
	let [contractRateList, setContractRateList] = useState([
		{
			_id: '68be6abbbc64c23b42025ad8',
			contractNumber: '299077507',
			commodity: 'WASTE PAPER',
			contractMonth: 'SEPTEMBER 2025',
			shipmentType: 'Ocean Shipment',
			freightCarrier: 'MAERSK',
			loadingCountry: 'PORTUGAL',
			destinationCountry: 'INDIA',
			destinationfreeDays: '14',
			priceDetails: [
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'JUDITE MARIA , CAMARATE',
					loadingPort: 'LISBON',
					destinationPort: 'MUNDRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 190,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 700,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687757ad1916092c37852942'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'FMR , CAMARATE',
					loadingPort: 'LISBON',
					destinationPort: 'MUNDRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 190,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 700,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687757b61916092c37852aee'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'BLUE OTTER , BUCELAS',
					loadingPort: 'LISBON',
					destinationPort: 'MUNDRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 190,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 700,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687757c11916092c37852c9b'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'BLUE PAPERS , FRIELAS',
					loadingPort: 'LISBON',
					destinationPort: 'MUNDRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 190,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 700,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687757cb1916092c37852e45'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'JOAO MANUEL AGUALVA , CACEM',
					loadingPort: 'LISBON',
					destinationPort: 'MUNDRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 198,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 700,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687757d41916092c3785301d'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'GANDARA , CACEM',
					loadingPort: 'LISBON',
					destinationPort: 'MUNDRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 198,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 700,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687757de1916092c378531f4'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'SAICA , RIO DE MOURO',
					loadingPort: 'LISBON',
					destinationPort: 'MUNDRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 198,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 700,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687757e71916092c3785339f'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'ANTIGA CASA POMPEU , PEDROSO',
					loadingPort: 'LEIXOES',
					destinationPort: 'MUNDRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 198,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 725,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687757f01916092c3785355c'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'J NUNES , SAO PAIO DE OLEIROS',
					loadingPort: 'LEIXOES',
					destinationPort: 'MUNDRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 198,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 700,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687757f91916092c37853727'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'VEOLIA , SANTO ANTAO DO TOJAL',
					loadingPort: 'LISBON',
					destinationPort: 'MUNDRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 198,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 700,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687758031916092c378538d5'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'SOCIEDADE AMARELISA , MOZELOS',
					loadingPort: 'LEIXOES',
					destinationPort: 'MUNDRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 190,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 700,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '6877580c1916092c37853aa6'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'SAICA NATUR , MOREIRA DA MAIA',
					loadingPort: 'LEIXOES',
					destinationPort: 'MUNDRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 173,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 700,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687758161916092c37853c87'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'GREEN PAPERS , BAGUIM DO MONTE',
					loadingPort: 'LEIXOES',
					destinationPort: 'MUNDRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 169,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 700,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687758201916092c37853e3f'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'CTR , TROFA',
					loadingPort: 'LEIXOES',
					destinationPort: 'MUNDRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 191,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 700,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '6877582a1916092c37853fea'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'BRACICLA , AMARES',
					loadingPort: 'LEIXOES',
					destinationPort: 'MUNDRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 255,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 725,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687758341916092c37854198'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'ECOCAR , TORRES VEDRAS',
					loadingPort: 'LISBON',
					destinationPort: 'MUNDRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 266,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 770,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '6877583e1916092c3785435f'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'BLUE OTTER , PALMELA',
					loadingPort: 'LISBON',
					destinationPort: 'MUNDRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 225,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 730,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687758481916092c3785450a'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'SERAICAL , VILA NOVA FAMALICAO',
					loadingPort: 'LEIXOES',
					destinationPort: 'MUNDRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 225,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 725,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687758521916092c378546dd'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'EURO SEPARADORA , VILA VERDE BRAGA',
					loadingPort: 'LEIXOES',
					destinationPort: 'MUNDRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 225,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 725,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '6877585c1916092c3785489b'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'SAICA NATUR , ALCOCHETE',
					loadingPort: 'LISBON',
					destinationPort: 'MUNDRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 225,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 750,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687758681916092c37854a72'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'TRIAGEM , MOITA',
					loadingPort: 'LISBON',
					destinationPort: 'MUNDRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 225,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 745,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687758731916092c37854c27'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'DOMINGOS MENDES ,  GUARDIZELA',
					loadingPort: 'LEIXOES',
					destinationPort: 'MUNDRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 225,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 725,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '6877587e1916092c37854e0f'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'REVALOR , ALCOBACA',
					loadingPort: 'LISBON',
					destinationPort: 'MUNDRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 385,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 875,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687758a61916092c37855068'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'LINHAMBIENTE , ANSIAO',
					loadingPort: 'LEIXOES',
					destinationPort: 'MUNDRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 500,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 1040,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687758b11916092c37855257'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'LINHAMBIENTE , MUGE',
					loadingPort: 'LISBON',
					destinationPort: 'MUNDRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 283,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 800,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687758c01916092c37855403'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'AMBY GROUP , SEIXAL',
					loadingPort: 'LISBON',
					destinationPort: 'MUNDRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 198,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 700,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687758cb1916092c378555ff'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'BLUE OTTER , LOURES',
					loadingPort: 'LISBON',
					destinationPort: 'MUNDRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 198,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 700,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687758fb1916092c378557cc'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'AMBY GROUP, CHAMUSCA',
					loadingPort: 'LISBON',
					destinationPort: 'MUNDRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 365,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 880,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687759131916092c3785597d'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'GREEN PAPER , SETUBAL',
					loadingPort: 'LISBON',
					destinationPort: 'MUNDRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 225,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 750,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687759221916092c37855b69'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'DS SMITH , FIGUEIRA DA FOZ',
					loadingPort: 'LEIXOES',
					destinationPort: 'MUNDRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 465,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 1000,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '6877593d1916092c37855d20'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'GOMES DE OLIVEIRA , ESMORIZ',
					loadingPort: 'LEIXOES',
					destinationPort: 'MUNDRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 198,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 970,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '6877595f1916092c37855ed2'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'DS SMITH , FANZERES',
					loadingPort: 'LEIXOES',
					destinationPort: 'MUNDRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 198,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 885,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687759771916092c378560ba'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'A.S. SIMOES , SEIXAL',
					loadingPort: 'LISBON',
					destinationPort: 'MUNDRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 198,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 700,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '68775a461916092c37856479'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'RECIPREMIO , CALDAS DA RAINHA',
					loadingPort: 'LISBON',
					destinationPort: 'MUNDRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 299,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 885,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '68775aea1916092c378567b0'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'JUDITE MARIA , CAMARATE',
					loadingPort: 'LISBON',
					destinationPort: 'HAZIRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 190,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 700,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '68775af41916092c37856961'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'FMR , CAMARATE',
					loadingPort: 'LISBON',
					destinationPort: 'HAZIRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 190,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 700,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '68775b011916092c37856b0b'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'BLUE OTTER , BUCELAS',
					loadingPort: 'LISBON',
					destinationPort: 'HAZIRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 190,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 700,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '68775b1a1916092c37856cbb'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'BLUE PAPERS , FRIELAS',
					loadingPort: 'LISBON',
					destinationPort: 'HAZIRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 190,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 700,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '68775b2b1916092c37856e71'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'JOAO MANUEL AGUALVA , CACEM',
					loadingPort: 'LISBON',
					destinationPort: 'HAZIRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 198,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 700,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '68775b3a1916092c37857020'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'GANDARA , CACEM',
					loadingPort: 'LISBON',
					destinationPort: 'HAZIRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 198,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 700,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '68775b461916092c37857252'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'SAICA , RIO DE MOURO',
					loadingPort: 'LISBON',
					destinationPort: 'HAZIRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 198,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 700,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '68775cec1916092c37857868'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'ANTIGA CASA POMPEU , PEDROSO',
					loadingPort: 'LEIXOES',
					destinationPort: 'HAZIRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 198,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 725,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '68775cf91916092c37857a36'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'J NUNES , SAO PAIO DE OLEIROS',
					loadingPort: 'LEIXOES',
					destinationPort: 'HAZIRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 198,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 700,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '68775d051916092c37857be4'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'VEOLIA , SANTO ANTAO DO TOJAL',
					loadingPort: 'LISBON',
					destinationPort: 'HAZIRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 198,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 700,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '68775d101916092c37857d8f'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'SOCIEDADE AMARELISA , MOZELOS',
					loadingPort: 'LEIXOES',
					destinationPort: 'HAZIRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 190,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 700,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '68775d1b1916092c37857f5e'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'SAICA NATUR , MOREIRA DA MAIA',
					loadingPort: 'LEIXOES',
					destinationPort: 'HAZIRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 173,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 700,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '68775d271916092c3785810a'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'GREEN PAPERS , BAGUIM DO MONTE',
					loadingPort: 'LEIXOES',
					destinationPort: 'HAZIRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 169,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 700,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '68775d3d1916092c378582b8'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'CTR , TROFA',
					loadingPort: 'LEIXOES',
					destinationPort: 'HAZIRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 191,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 700,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '68775d491916092c378584ae'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'BRACICLA , AMARES',
					loadingPort: 'LEIXOES',
					destinationPort: 'HAZIRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 255,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 725,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '68775d551916092c3785865a'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'ECOCAR , TORRES VEDRAS',
					loadingPort: 'LISBON',
					destinationPort: 'HAZIRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 266,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 770,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '68775d811916092c378588c4'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'BLUE OTTER , PALMELA',
					loadingPort: 'LISBON',
					destinationPort: 'HAZIRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 225,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 730,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '68775d8d1916092c37858a6f'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'SERAICAL , VILA NOVA FAMALICAO',
					loadingPort: 'LEIXOES',
					destinationPort: 'HAZIRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 225,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 725,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '68775d971916092c37858c1f'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'EURO SEPARADORA , VILA VERDE BRAGA',
					loadingPort: 'LEIXOES',
					destinationPort: 'HAZIRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 225,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 725,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '68775da31916092c37858dc8'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'SAICA NATUR , ALCOCHETE',
					loadingPort: 'LISBON',
					destinationPort: 'HAZIRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 225,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 750,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '68775dad1916092c37858f75'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'TRIAGEM , MOITA',
					loadingPort: 'LISBON',
					destinationPort: 'HAZIRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 225,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 745,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '68775db91916092c37859120'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'DOMINGOS MENDES ,  GUARDIZELA',
					loadingPort: 'LEIXOES',
					destinationPort: 'HAZIRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 225,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 725,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '68775dd71916092c3785930f'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'REVALOR , ALCOBACA',
					loadingPort: 'LISBON',
					destinationPort: 'HAZIRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 385,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 875,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '68775de31916092c378594b9'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'LINHAMBIENTE , ANSIAO',
					loadingPort: 'LEIXOES',
					destinationPort: 'HAZIRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 500,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 1040,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '68775df21916092c37859662'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'LINHAMBIENTE , MUGE',
					loadingPort: 'LISBON',
					destinationPort: 'HAZIRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 283,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 800,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '68775dfd1916092c3785980e'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'AMBY GROUP , SEIXAL',
					loadingPort: 'LISBON',
					destinationPort: 'HAZIRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 198,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 700,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '68775e091916092c378599b8'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'BLUE OTTER , LOURES',
					loadingPort: 'LISBON',
					destinationPort: 'HAZIRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 198,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 700,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '68775e181916092c37859b68'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'AMBY GROUP , CHAMUSCA',
					loadingPort: 'LISBON',
					destinationPort: 'HAZIRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 365,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 880,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '68775e231916092c37859d12'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'GREEN PAPER , SETUBAL',
					loadingPort: 'LISBON',
					destinationPort: 'HAZIRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 225,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 750,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '68775e2f1916092c37859f4a'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'DS SMITH , FIGUEIRA DA FOZ',
					loadingPort: 'LEIXOES',
					destinationPort: 'HAZIRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 465,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 1000,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '68775e3d1916092c3785a112'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'GOMES DE OLIVEIRA , ESMORIZ',
					loadingPort: 'LEIXOES',
					destinationPort: 'HAZIRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 198,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 970,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '68775e491916092c3785a2be'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'DS SMITH , FANZERES',
					loadingPort: 'LEIXOES',
					destinationPort: 'HAZIRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 198,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 885,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '68775e6a1916092c3785a46d'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'A.S. SIMOES , SEIXAL',
					loadingPort: 'LISBON',
					destinationPort: 'HAZIRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 198,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 700,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '68775e781916092c3785a619'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'RECIPREMIO , CALDAS DA RAINHA',
					loadingPort: 'LISBON',
					destinationPort: 'HAZIRA',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 299,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 885,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '68775ee31916092c3785a85c'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'JUDITE MARIA , CAMARATE',
					loadingPort: 'LISBON',
					destinationPort: 'PIPAVAV PORT',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 190,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 700,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '68775f241916092c3785aa22'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'FMR , CAMARATE',
					loadingPort: 'LISBON',
					destinationPort: 'PIPAVAV PORT',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 190,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 700,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '68775f361916092c3785abd0'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'BLUE OTTER , BUCELAS',
					loadingPort: 'LISBON',
					destinationPort: 'PIPAVAV PORT',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 190,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 700,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '68775f481916092c3785ad81'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'BLUE PAPERS , FRIELAS',
					loadingPort: 'LISBON',
					destinationPort: 'PIPAVAV PORT',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 190,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 700,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687781861916092c3786040d'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'JOAO MANUEL AGUALVA , CACEM',
					loadingPort: 'LISBON',
					destinationPort: 'PIPAVAV PORT',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 198,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 700,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687781921916092c378605b8'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'GANDARA , CACEM',
					loadingPort: 'LISBON',
					destinationPort: 'PIPAVAV PORT',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 198,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 700,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687781a01916092c37860762'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'SAICA , RIO DE MOURO',
					loadingPort: 'LISBON',
					destinationPort: 'PIPAVAV PORT',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 198,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 700,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687781ab1916092c3786090b'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'ANTIGA CASA POMPEU , PEDROSO',
					loadingPort: 'LEIXOES',
					destinationPort: 'PIPAVAV PORT',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 198,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 725,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687781b91916092c37860ab9'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'J NUNES , SAO PAIO DE OLEIROS',
					loadingPort: 'LEIXOES',
					destinationPort: 'PIPAVAV PORT',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 198,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 700,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687781c51916092c37860c65'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'SOCIEDADE AMARELISA , MOZELOS',
					loadingPort: 'LEIXOES',
					destinationPort: 'PIPAVAV PORT',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 190,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 700,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687781d21916092c37860e10'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'SAICA NATUR , MOREIRA DA MAIA',
					loadingPort: 'LEIXOES',
					destinationPort: 'PIPAVAV PORT',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 173,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 700,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687781f21916092c378610db'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'GREEN PAPERS , BAGUIM DO MONTE',
					loadingPort: 'LEIXOES',
					destinationPort: 'PIPAVAV PORT',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 169,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 700,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687781fe1916092c37861285'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'CTR , TROFA',
					loadingPort: 'LEIXOES',
					destinationPort: 'PIPAVAV PORT',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 191,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 700,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '6877820a1916092c37861432'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'BRACICLA , AMARES',
					loadingPort: 'LEIXOES',
					destinationPort: 'PIPAVAV PORT',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 255,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 725,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '6877821b1916092c378615dd'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'ECOCAR , TORRES VEDRAS',
					loadingPort: 'LISBON',
					destinationPort: 'PIPAVAV PORT',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 265,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 770,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687782281916092c37861786'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'BLUE OTTER , PALMELA',
					loadingPort: 'LISBON',
					destinationPort: 'PIPAVAV PORT',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 225,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 730,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687782391916092c37861934'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'SERAICAL , VILA NOVA FAMALICAO',
					loadingPort: 'LEIXOES',
					destinationPort: 'PIPAVAV PORT',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 225,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 725,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687782471916092c37861ae2'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'EURO SEPARADORA , VILA VERDE BRAGA',
					loadingPort: 'LEIXOES',
					destinationPort: 'PIPAVAV PORT',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 225,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 725,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687782551916092c37861c8d'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'SAICA NATUR , ALCOCHETE',
					loadingPort: 'LISBON',
					destinationPort: 'PIPAVAV PORT',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 225,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 750,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687782631916092c37861e37'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'TRIAGEM , MOITA',
					loadingPort: 'LISBON',
					destinationPort: 'PIPAVAV PORT',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 225,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 745,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '6877826d1916092c37861fe5'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'DOMINGOS MENDES ,  GUARDIZELA',
					loadingPort: 'LEIXOES',
					destinationPort: 'PIPAVAV PORT',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 225,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 725,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687782791916092c37862190'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'REVALOR , ALCOBACA',
					loadingPort: 'LISBON',
					destinationPort: 'PIPAVAV PORT',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 385,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 875,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687782871916092c378623bd'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'LINHAMBIENTE , ANSIAO',
					loadingPort: 'LEIXOES',
					destinationPort: 'PIPAVAV PORT',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 500,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 1040,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687782951916092c37862567'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'LINHAMBIENTE , MUGE',
					loadingPort: 'LISBON',
					destinationPort: 'PIPAVAV PORT',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 283,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 800,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687782a11916092c37862749'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'AMBY GROUP , SEIXAL',
					loadingPort: 'LISBON',
					destinationPort: 'PIPAVAV PORT',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 198,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 700,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687782ae1916092c378628f6'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'BLUE OTTER , LOURES',
					loadingPort: 'LISBON',
					destinationPort: 'PIPAVAV PORT',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 198,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 700,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687782bc1916092c37862aa2'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'AMBY GROUP , CHAMUSCA',
					loadingPort: 'LISBON',
					destinationPort: 'PIPAVAV PORT',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 365,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 880,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687782c91916092c37862c4d'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'GREEN PAPER , SETUBAL',
					loadingPort: 'LISBON',
					destinationPort: 'PIPAVAV PORT',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 225,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 750,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687782d81916092c37862e30'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'DS SMITH , FIGUEIRA DA FOZ',
					loadingPort: 'LEIXOES',
					destinationPort: 'PIPAVAV PORT',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 465,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 1000,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687782e51916092c37862ffc'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'GOMES DE OLIVEIRA , ESMORIZ',
					loadingPort: 'LEIXOES',
					destinationPort: 'PIPAVAV PORT',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 198,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 970,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687782f21916092c378631c6'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'DS SMITH , FANZERES',
					loadingPort: 'LEIXOES',
					destinationPort: 'PIPAVAV PORT',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 198,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 885,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687782fd1916092c37863372'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'A.S. SIMOES , SEIXAL',
					loadingPort: 'LISBON',
					destinationPort: 'PIPAVAV PORT',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 198,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 700,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '6877830c1916092c3786351c'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'RECIPREMIO , CALDAS DA RAINHA',
					loadingPort: 'LISBON',
					destinationPort: 'PIPAVAV PORT',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 299,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 885,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687783171916092c378636c7'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'VEOLIA , SANTO ANTAO DO TOJAL',
					loadingPort: 'LISBON',
					destinationPort: 'PIPAVAV PORT',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 198,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 700,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687783211916092c37863874'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'JUDITE MARIA , CAMARATE',
					loadingPort: 'LISBON',
					destinationPort: 'JAWAHARLAL NEHRU (NHAVA SHEVA)',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 190,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 700,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '6877832d1916092c37863a1f'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'FMR , CAMARATE',
					loadingPort: 'LISBON',
					destinationPort: 'JAWAHARLAL NEHRU (NHAVA SHEVA)',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 190,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 700,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687783371916092c37863bcb'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'BLUE OTTER , BUCELAS',
					loadingPort: 'LISBON',
					destinationPort: 'JAWAHARLAL NEHRU (NHAVA SHEVA)',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 190,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 700,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687783451916092c37863d75'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'BLUE PAPERS , FRIELAS',
					loadingPort: 'LISBON',
					destinationPort: 'JAWAHARLAL NEHRU (NHAVA SHEVA)',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 190,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 700,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687783521916092c37863f20'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'JOAO MANUEL AGUALVA , CACEM',
					loadingPort: 'LISBON',
					destinationPort: 'JAWAHARLAL NEHRU (NHAVA SHEVA)',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 198,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 700,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687783621916092c378640ce'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'GANDARA , CACEM',
					loadingPort: 'LISBON',
					destinationPort: 'JAWAHARLAL NEHRU (NHAVA SHEVA)',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 198,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 700,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '6877836e1916092c3786427c'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'SAICA , RIO DE MOURO',
					loadingPort: 'LISBON',
					destinationPort: 'JAWAHARLAL NEHRU (NHAVA SHEVA)',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 198,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 700,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '6877837a1916092c37864426'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'ANTIGA CASA POMPEU , PEDROSO',
					loadingPort: 'LEIXOES',
					destinationPort: 'JAWAHARLAL NEHRU (NHAVA SHEVA)',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 198,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 725,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '6877838a1916092c378645d1'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'J NUNES , SAO PAIO DE OLEIROS',
					loadingPort: 'LEIXOES',
					destinationPort: 'JAWAHARLAL NEHRU (NHAVA SHEVA)',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 198,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 700,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687783961916092c3786477d'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'VEOLIA , SANTO ANTAO DO TOJAL',
					loadingPort: 'LISBON',
					destinationPort: 'JAWAHARLAL NEHRU (NHAVA SHEVA)',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 198,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 700,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687783a21916092c3786492a'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'SOCIEDADE AMARELISA , MOZELOS',
					loadingPort: 'LEIXOES',
					destinationPort: 'JAWAHARLAL NEHRU (NHAVA SHEVA)',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 190,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 700,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687783ac1916092c37864ae3'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'SAICA NATUR , MOREIRA DA MAIA',
					loadingPort: 'LEIXOES',
					destinationPort: 'JAWAHARLAL NEHRU (NHAVA SHEVA)',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 173,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 700,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687783b81916092c37864c8d'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'GREEN PAPERS , BAGUIM DO MONTE',
					loadingPort: 'LEIXOES',
					destinationPort: 'JAWAHARLAL NEHRU (NHAVA SHEVA)',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 169,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 700,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687783c51916092c37864e4f'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'CTR , TROFA',
					loadingPort: 'LEIXOES',
					destinationPort: 'JAWAHARLAL NEHRU (NHAVA SHEVA)',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 191,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 700,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687783d01916092c37864ffd'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'SOCIEDADE AMARELISA , MOZELOS',
					loadingPort: 'LEIXOES',
					destinationPort: 'JAWAHARLAL NEHRU (NHAVA SHEVA)',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 255,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 700,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687783e01916092c378651e0'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'ECOCAR , TORRES VEDRAS',
					loadingPort: 'LISBON',
					destinationPort: 'JAWAHARLAL NEHRU (NHAVA SHEVA)',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 265,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 770,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687783f11916092c3786538d'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'BLUE OTTER , PALMELA',
					loadingPort: 'LISBON',
					destinationPort: 'JAWAHARLAL NEHRU (NHAVA SHEVA)',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 225,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 730,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687783ff1916092c37865539'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'SERAICAL , VILA NOVA FAMALICAO',
					loadingPort: 'LEIXOES',
					destinationPort: 'JAWAHARLAL NEHRU (NHAVA SHEVA)',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 225,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 725,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '6877840e1916092c378656f3'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'EURO SEPARADORA , VILA VERDE BRAGA',
					loadingPort: 'LEIXOES',
					destinationPort: 'JAWAHARLAL NEHRU (NHAVA SHEVA)',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 225,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 725,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '6877841e1916092c378658a1'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'SAICA NATUR , ALCOCHETE',
					loadingPort: 'LISBON',
					destinationPort: 'JAWAHARLAL NEHRU (NHAVA SHEVA)',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 225,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 750,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '6877842b1916092c37865afa'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'TRIAGEM , MOITA',
					loadingPort: 'LISBON',
					destinationPort: 'JAWAHARLAL NEHRU (NHAVA SHEVA)',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 225,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 745,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687784371916092c37865cb1'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'DOMINGOS MENDES ,  GUARDIZELA',
					loadingPort: 'LEIXOES',
					destinationPort: 'JAWAHARLAL NEHRU (NHAVA SHEVA)',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 225,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 725,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687784451916092c37865ea0'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'REVALOR , ALCOBACA',
					loadingPort: 'LISBON',
					destinationPort: 'JAWAHARLAL NEHRU (NHAVA SHEVA)',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 365,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 875,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687784551916092c3786609c'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'LINHAMBIENTE , ANSIAO',
					loadingPort: 'LEIXOES',
					destinationPort: 'JAWAHARLAL NEHRU (NHAVA SHEVA)',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 500,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 1040,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687784611916092c3786624a'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'LINHAMBIENTE , MUGE',
					loadingPort: 'LISBON',
					destinationPort: 'JAWAHARLAL NEHRU (NHAVA SHEVA)',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 283,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 800,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '6877846b1916092c378663f5'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'AMBY GROUP , SEIXAL',
					loadingPort: 'LISBON',
					destinationPort: 'JAWAHARLAL NEHRU (NHAVA SHEVA)',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 198,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 700,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687784761916092c378665a8'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'BLUE OTTER , LOURES',
					loadingPort: 'LISBON',
					destinationPort: 'JAWAHARLAL NEHRU (NHAVA SHEVA)',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 198,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 700,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687784811916092c37866753'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'AMBY GROUP , CHAMUSCA',
					loadingPort: 'LISBON',
					destinationPort: 'JAWAHARLAL NEHRU (NHAVA SHEVA)',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 365,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 880,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '6877848c1916092c37866900'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'GREEN PAPER , SETUBAL',
					loadingPort: 'LISBON',
					destinationPort: 'JAWAHARLAL NEHRU (NHAVA SHEVA)',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 225,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 750,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687784961916092c37866aaa'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'DS SMITH , FIGUEIRA DA FOZ',
					loadingPort: 'LEIXOES',
					destinationPort: 'JAWAHARLAL NEHRU (NHAVA SHEVA)',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 465,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 1000,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '6877849f1916092c37866c73'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'GOMES DE OLIVEIRA , ESMORIZ',
					loadingPort: 'LEIXOES',
					destinationPort: 'JAWAHARLAL NEHRU (NHAVA SHEVA)',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 198,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 970,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687784a91916092c37866e35'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'DS SMITH , FANZERES',
					loadingPort: 'LEIXOES',
					destinationPort: 'JAWAHARLAL NEHRU (NHAVA SHEVA)',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 198,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 885,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687784b41916092c37866fe4'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'A.S. SIMOES , SEIXAL',
					loadingPort: 'LISBON',
					destinationPort: 'JAWAHARLAL NEHRU (NHAVA SHEVA)',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 198,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 700,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687784bf1916092c37867199'
				},
				{
					priceType: 'Ex Works Price',
					loadingSupplierLocation: 'RECIPREMIO , CALDAS DA RAINHA',
					loadingPort: 'LISBON',
					destinationPort: 'JAWAHARLAL NEHRU (NHAVA SHEVA)',
					currency: 'USD',
					freightPrice: 275,
					transportPrice: 299,
					miscCharges: 159,
					priceNotes: '',
					totalPrice: 885,
					createdBy: 'MOHIT JANGID',
					createdAt: '2025-07-15T15:54:38.089Z',
					_id: '687784cb1916092c37867381'
				}
			],
			createdBy: 'ABHAY KUMBHAT',
			createdAt: '2025-09-08T05:33:47.305Z'
		}
	]);
	const toggle = id => {
		if (open === id) {
			setOpen();
		} else {
			setOpen(id);
		}
	};
	return (
		<React.Fragment>
			<div className="page-content">
				<Container fluid>
					{/* Render Breadcrumb */}
					<Breadcrumbs title={props.t('Contract Rates')} breadcrumbItem={props.t('Rates')} />

					<Row>
						<Col className="text-center mt-5" xl="12">
							{contractRateList?.length > 0 &&
								!isLoading &&
								contractRateList?.map((item, index) => (
									<Accordion key={item._id} open={open} toggle={toggle}>
										<AccordionItem>
											<AccordionHeader targetId={item._id}>
												<Row className="w-100">
													<Col>
														<div className="font-size-12 mb-2">
															{item?.loadingCountry} - {item?.destinationCountry}
														</div>
														<div className="font-size-12 mb-2">
															Commodity : {item?.commodity} , Free Days : {item?.destinationfreeDays}
														</div>
														<div className="font-size-12 mb-2">Valid Until : 30 SEPTEMBER 2025</div>
													</Col>
													<Col>
														<div className="text-sm-end">
															<button
																type="button"
																onClick={() => {
																	setSelectedData(item);
																	setCopyModalVisible(true);
																}}
																className="btn btn-success btn-rounded btn-sm me-2"
															>
																<i className="bx bx-copy me-1"></i> Contract &nbsp;
															</button>
														</div>
													</Col>
												</Row>
											</AccordionHeader>
											<AccordionBody accordionId={item._id}>
												<Row>
													<Col sm="12">
														<div className="table-responsive">
															<table className="table align-middle table-nowrap mb-0">
																<thead className="table-light font-size-11">
																	<tr>
																		<th className="align-middle text-center">Sr #</th>
																		<th className="align-middle text-center">Price Type</th>
																		<th className="align-middle text-center">Loading Location</th>
																		<th className="align-middle text-center">POL</th>
																		<th className="align-middle text-center">POD</th>
																		{/* <th className="align-middle text-center">Freight Price</th>
																		<th className="align-middle text-center">Transport Price</th>
																		<th className="align-middle text-center">Miscellaneous Charges</th> */}
																		<th className="align-middle text-center">Total Price</th>
																		<th className="align-middle text-center">Action</th>
																	</tr>
																</thead>
																<tbody key={'customer-member-table'} className="font-size-11">
																	{item?.priceDetails?.map((data, ind) => (
																		<tr key={'customer-member-table-' + ind}>
																			<td className="text-center">{ind + 1}</td>
																			<td className="text-center">{data?.priceType}</td>
																			<td className="text-center">{data?.loadingSupplierLocation || '-'}</td>
																			<td className="text-center">{data?.loadingPort}</td>
																			<td className="text-center">{data?.destinationPort}</td>
																			{/* <td className="text-center">
																				{data?.currency} {data?.freightPrice}
																			</td>
																			<td className="text-center">
																				{data?.currency} {data?.transportPrice}
																			</td>
																			<td className="text-center">
																				{data?.currency} {data?.miscCharges}
																			</td> */}
																			<td className="text-center">
																				{data?.currency} {data?.totalPrice}
																			</td>
																			<td className="text-center">
																				<ul className="list-inline font-size-20 contact-links mb-0">
																					<li className="list-inline-item px-2">
																						<button className="btn btn-primary">Send Booking Request</button>
																					</li>
																				</ul>
																			</td>
																		</tr>
																	))}
																	{item?.priceDetails?.length === 0 && (
																		<tr key={'customer-member-empty'}>
																			<td className="text-center" colSpan="12">
																				No Price Found
																			</td>
																		</tr>
																	)}
																</tbody>
															</table>
														</div>
													</Col>
												</Row>
											</AccordionBody>
										</AccordionItem>
									</Accordion>
								))}
						</Col>
					</Row>
				</Container>
			</div>
		</React.Fragment>
	);
};
ContractRates.propTypes = {
	t: PropTypes.any
};

export default withTranslation()(ContractRates);
